/*
 * layout view for the response area
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesHeader/template/topicCategoriesHeader.html",
], function (Marionette, HeaderTemplate) {
  var TopicCategoriesHeaderView = {};

  TopicCategoriesHeaderView.headerLayout = Marionette.Layout.extend({
    template: HeaderTemplate,
    triggers: {
      "click #addCategory": "add:category",
    },
  });

  return TopicCategoriesHeaderView;
});
